import React from "react";
import SEO from "../components/site/SEO";

export default function APropos() {
    return (
        <div data-testid="page-apropos" className="pt-32 pb-24 px-6 md:px-12 lg:px-24">
            <SEO title="À propos" description="Paul, photographe basé en France. Approche cinématographique, livraison soignée — du moodboard au tirage final." />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
                <div>
                    <p className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">— À propos</p>
                    <h1 className="font-serif-display text-5xl md:text-7xl leading-[0.95]">
                        Paul,<br />
                        <em className="italic text-[#c5a059]">derrière l'objectif.</em>
                    </h1>
                    <div className="mt-10 space-y-6 text-zinc-300 leading-relaxed max-w-xl">
                        <p>
                            Photographe basé en France, je m'attache à capturer ce
                            qu'on ne voit qu'une fois — le reflet d'un capot poli
                            sous un lampadaire, le regard d'une mariée juste avant
                            qu'elle ne se retourne, la main d'un enfant qui découvre
                            son propre prénom.
                        </p>
                        <p>
                            Mon approche est cinématographique : lumière travaillée,
                            cadres tenus, post-production discrète. Je ne mets pas
                            en scène l'instant, je l'attends.
                        </p>
                        <p>
                            Que ce soit pour une supercar, un mariage ou un baptême,
                            je propose un accompagnement personnalisé et une livraison
                            soignée — du moodboard jusqu'au tirage final.
                        </p>
                    </div>
                </div>

                <div className="relative">
                    <img
                        src="https://images.pexels.com/photos/10620268/pexels-photo-10620268.jpeg"
                        alt="Paul portrait"
                        className="w-full aspect-[4/5] object-cover border border-white/10"
                    />
                    <div className="absolute -bottom-6 -left-6 bg-[#c5a059] text-black px-6 py-4 hidden md:block">
                        <p className="text-xs uppercase tracking-[0.25em]">Depuis</p>
                        <p className="font-serif-display text-3xl">2019</p>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-24 md:mt-32 border-t border-white/10 pt-16">
                {[
                    { n: "120+", l: "Shootings réalisés" },
                    { n: "45+", l: "Mariages couverts" },
                    { n: "6", l: "Années d'expérience" },
                ].map((s) => (
                    <div key={s.l}>
                        <p className="font-serif-display text-6xl text-[#c5a059]">{s.n}</p>
                        <p className="text-xs uppercase tracking-[0.25em] text-zinc-500 mt-2">{s.l}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
